<template>
  <mds-modal
    size="large"
    :width="'1200px'"
    aria-label="Large Modal"
    v-model="isopenModel"
    title=""
    action-required
  >
    <super-advance-filter
      :filterInfo="filterInfo"
      :filterOptions="filterOptions"
      :sections="sections"
      :menus="menus"
      :subMenus="subMenus"
      @onClick="onClick"
      @buttonclick="genericMethodClick"
      :clientId="clientId"
    >
      <template #dynamic-content v-if="selectedComponent && selectedComponent != ''">
        <component
          ref="filtercontent"
          :key="componentKey"
          :is="selectedComponent"
          :baselineData="baselineFilterObject"
          @resetBaselineData="resetBaselineData"
          :clientId="clientId"
          :sectionTitle="sectionTitle"
          :clientName="clientName"
          @openErrorTab="openErrorTab"
        ></component>
      </template>
    </super-advance-filter>
  </mds-modal>
</template>
<script>
import { SuperAdvanceFilter } from "../../component/tool";
import MdsModal from "@mds/modal";
import SuperAdvanceModel from "../../models/superAdvanceFilter";
import AdvanceAccumulation from "./advance-accumulation";
import AdvanceContribution from "./advance-contribution";
import AdvancePension from "./advance-pension";
import AdvanceFeeAccumulation from "./advance-fee-accumulation.vue";
import AdvanceFeePension from "./advance-fee-pension.vue";
import AdvanceWithdrawalPension from "./advance-withdrawal-pension";
import AdvanceWithdrawalAccumulation from "./advance-withdrawal-accumulation";
import AdvancePensionPayment from "./advance-pension-payment.vue";
import SuperMarketcrashFilter from "./super-marketcrash-filter";
import { CommonHelper } from "../../helpers";
import { SuperannuationEngagementTool } from "../../mixin";
import {
  AdvanceSuperFilter,
  AdvanceSuperFilterComponents,
} from "../../helpers/constant";
import {
  GET_SUPERANNUATION_ENTITY_INFORMATION,
  GET_SELECTED_SUPERANNUATION_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
export default {
  props: {
    selectMenu: {
      type: Number,
    },
    selectedSubMenu: {
      type: Number,
    },
    isopenModel: {
      type: Boolean,
    },
    baselineData: {
      type: Object,
    },
    openTabName: {
      type: String,
    },
    selectedClientId: {
      type: Number,
    },
    selectedMenuId: {
      type: Number,
    },
    subMenuId: {
      type: Number,
    },
  },
  mixins: [SuperannuationEngagementTool],
  components: {
    SuperAdvanceFilter,
    AdvanceAccumulation,
    AdvanceContribution,
    AdvancePension,
    SuperMarketcrashFilter,
    MdsModal,
    AdvanceWithdrawalPension,
    AdvanceWithdrawalAccumulation,
    AdvancePensionPayment,
    AdvanceFeeAccumulation,
    AdvanceFeePension
  },
  data() {
    return {
      selectedValue: 0,
      componentKey: 0,
      clientId: this.selectedClientId,
      // this.selectedSection == undefined
      //   ? this.baselineData.fundDetails[0].clientId
      //   : this.selectedSection,
      clientName: "",
      sectionTitle: "",
      baselineFilterObject: Object.assign([], this.baselineData),
      selectedComponent: this.openTabName,
      mainMenuId: 0,
      selectedSection: 0,
      selectedMenu: 0,
      selectedSubMenuId: 0,
      refreshkey: 0,
      filterInfo: {
        title: "Advanced Setting",
        borderPosition: "bottom",
        actionButtons: [
          {
            method: "closeAdvancedFilter",
            variation: "secondary",
            text: "Cancel",
            id: "superannuationAdvancedFilter_2",
          },
          {
            method: "applyAdvancedSetting",
            variation: "primary",
            text: "Apply Changes",
            id: "superannuationAdvancedFilter_1",
          },
        ],
      },
    };
  },
  mounted() {
    this.clientId = this.selectedClientId;
    this.selectedSection = this.getSelectedSection(this.clientId);
    this.selectedMenu = this.selectedMenuId;
    this.selectedSubMenuId = this.subMenuId;
    if(this.baselineData){
    this.baselineData.superAddtionalDetails = this.createrowModel(
      this.selectedSuperannuationData.superAddtionalDetails
    );
    }
    this.loadMenuView();
    this.openTab();
  },

  computed: {
    ...mapGetters("superannuation", {
      clientInfo: GET_SUPERANNUATION_ENTITY_INFORMATION,
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
    }),
    sections() {
      return SuperAdvanceModel.getSection(this.clientInfo);
    },
    menus() {
      this.refreshkey;
      return SuperAdvanceModel.getMenus(
        this.sections,
        this.selectedMenu,
        this.selectedSection
      );
    },
    subMenus() {
      this.refreshkey;
      return SuperAdvanceModel.getSubMenus(
        this.menus,
        this.selectedSection,
        this.selectedMenu,
        this.selectedSubMenuId
      );
    },
  },

  async created() {},
  methods: {
    getSelectedSection(clientId) {
      let selectedIndex = this.sections.findIndex((sr) => sr.id == clientId);
      if (selectedIndex >= 0) {
        return this.sections[selectedIndex].id;
      } else {
        return this.sections[0].id;
      }
    },
    loadMenuView() {
      this.selectedValue =
        this.openTabName == AdvanceSuperFilterComponents.Accumulation
          ? AdvanceSuperFilter.Accumulation
          : this.openTabName == AdvanceSuperFilterComponents.Pension
          ? AdvanceSuperFilter.Pension
          : this.openTabName == AdvanceSuperFilterComponents.Contribution
          ? AdvanceSuperFilter.Contribution
          : this.openTabName == AdvanceSuperFilterComponents.MarketCrash
          ? AdvanceSuperFilter.MarketCrash
          : this.openTabName ==
            AdvanceSuperFilterComponents.WithdrawalAccumulation
          ? AdvanceSuperFilter.WithdrawalAccumulation
          : this.openTabName == AdvanceSuperFilterComponents.WithdrawalPension
          ? AdvanceSuperFilter.WithdrawalPension
          : this.openTabName ==
            AdvanceSuperFilterComponents.FeeAccumulation
          ? AdvanceSuperFilter.FeeAccumulation
          : this.openTabName == AdvanceSuperFilterComponents.FeePension
          ? AdvanceSuperFilter.FeePension
          : this.openTabName == AdvanceSuperFilterComponents.PensionPayment
          ? AdvanceSuperFilter.PensionPayment
          : 0;
    },

    openTab() {
      if (this.selectedValue == AdvanceSuperFilter.Accumulation) {
        this.selectedComponent = AdvanceSuperFilterComponents.Accumulation;
      } else if (this.selectedValue == AdvanceSuperFilter.WithdrawalPension) {
        this.selectedComponent = AdvanceSuperFilterComponents.WithdrawalPension;
      } else if (
        this.selectedValue == AdvanceSuperFilter.WithdrawalAccumulation
      ) {
        this.selectedComponent =
          AdvanceSuperFilterComponents.WithdrawalAccumulation;
      } else if (
        this.selectedValue == AdvanceSuperFilter.Pension ||
        this.selectedValue == AdvanceSuperFilter.WithdrawalPension
      ) {
        this.selectedComponent = AdvanceSuperFilterComponents.Pension;
      } else if (this.selectedValue == AdvanceSuperFilter.Contribution) {
        this.selectedComponent = AdvanceSuperFilterComponents.Contribution;
      } else if (this.selectedValue == AdvanceSuperFilter.MarketCrash) {
        this.selectedComponent = AdvanceSuperFilterComponents.MarketCrash;
      } else if (this.selectedValue == AdvanceSuperFilter.PensionPayment) {
        this.selectedComponent = AdvanceSuperFilterComponents.PensionPayment;
      }
      else if (this.selectedValue == AdvanceSuperFilter.FeeAccumulation) {
        this.selectedComponent = AdvanceSuperFilterComponents.FeeAccumulation;
      }
      else if (this.selectedValue == AdvanceSuperFilter.FeePension) {
        this.selectedComponent = AdvanceSuperFilterComponents.FeePension;
      }
      this.clientId = this.sections.filter(
        (sr) => sr.id == this.selectedSection
      )[0].id;
      this.clientName = this.sections.filter(
        (sr) => sr.id == this.selectedSection
      )[0].name;
    },

    onClick(sectionId, menuId, submenuId) {
      this.componentKey += 1;
      this.selectedSection = sectionId;
      this.selectedMenu = menuId;
      this.selectedSubMenuId = submenuId;
      this.selectedValue = submenuId == 0 ? menuId : submenuId;
      this.refreshkey++;
      this.openTab();
    },
    openErrorTab(tabDetails) {
      this.selectedValue = tabDetails.subTypeId;
      this.selectedSection = tabDetails.clientId;
      this.selectedMenu = tabDetails.typeId;
      this.selectedSubMenuId = tabDetails.subTypeId;
      this.openTab();
    },
    resetBaselineData(changedBaselineObject) {
      this.baselineFilterObject = changedBaselineObject;
    },
    genericMethodClick(function_name) {
      this[function_name]();
    },
    getvalue(data) {
      if (data == undefined) return 0;
      else return data.value;
    },

    async applyAdvancedSetting() {
      this.$refs.filtercontent.fillSuperannuationModel(this.selectedValue);
      let iserrorPresentInCurrentTab =
        this.$refs.filtercontent.superValidations(
          this.baselineFilterObject.superAddtionalDetails,
          this.selectedValue,
          this.clientId
        );
      if (iserrorPresentInCurrentTab) {
        return;
      }
      let isErrorPresent =
        this.$refs.filtercontent.IsAnySuperOptionHaveInvalidData(
          this.baselineFilterObject.Errors
        );
      if (isErrorPresent) return;

      if (
        this.baselineFilterObject.Errors.Accumulation.length == 0 &&
        this.baselineFilterObject.Errors.WithdrawalPension.length == 0 &&
        this.baselineFilterObject.Errors.WithdrawalAccumulation.length == 0 &&
        this.baselineFilterObject.Errors.FeeAccumulation.length == 0 &&
        this.baselineFilterObject.Errors.FeePension.length == 0 &&
        this.baselineFilterObject.Errors.MarketCrash.length == 0 &&
        this.baselineFilterObject.Errors.Contribution.length == 0 &&
        this.baselineFilterObject.Errors.Pension.length == 0 &&
        this.baselineFilterObject.Errors.PensionPayment.length == 0
      ) {
        this.baselineFilterObject.superAddtionalDetails.forEach(element => {
        if (element.typeId.value == AdvanceSuperFilter.FeeAccumulation || element.typeId.value == AdvanceSuperFilter.FeePension) {
          if (element.amount1.disable)
            element.amount1.value = 0;
          if (element.amount2.disable)
            element.amount2.value = 0;
          if (element.amount3.disable)
            element.amount3.value = 0;
          if (element.index.disable)
            element.index.value = 0;
          if (element.frequency.disable)
            element.frequency.value = 0;
        }
      });
        let newAdditionalDetails = CommonHelper.ConvertObjectIntoApiModel(
          this.baselineFilterObject.superAddtionalDetails
        );
        let currentObject = Object.assign([], this.baselineFilterObject);
        currentObject.superAddtionalDetails = newAdditionalDetails;

        this.$emit("saveData", currentObject);
      }
    },

    closeAdvancedFilter() {
      this.selectedValue = AdvanceSuperFilter.Accumulation;
      this.selectedComponent = AdvanceSuperFilterComponents.Accumulation;
      this.$emit("closeModel");
    },

    onFilterSelected(filterOption) {
      this.selectedValue = filterOption.value;
      this.openTab();
    },
  },
};
</script>
<style lang="scss" module></style>
 